/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_A2Inputs */

const en_to_yaml_faq_a2 = /** @type {(inputs: To_Yaml_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. YAML is a superset of JSON, so all JSON data types (strings, numbers, booleans, null, arrays, objects) are fully supported.`)
};

const ko_to_yaml_faq_a2 = /** @type {(inputs: To_Yaml_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. YAML은 JSON의 상위 집합이므로 모든 JSON 데이터 타입(문자열, 숫자, 불리언, null, 배열, 객체)을 완벽하게 지원합니다.`)
};

const ja_to_yaml_faq_a2 = /** @type {(inputs: To_Yaml_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。YAMLはJSONのスーパーセットなので、すべてのJSONデータ型（文字列、数値、ブーリアン、null、配列、オブジェクト）を完全にサポートしています。`)
};

/**
* | output |
* | --- |
* | "Yes. YAML is a superset of JSON, so all JSON data types (strings, numbers, booleans, null, arrays, objects) are fully supported." |
*
* @param {To_Yaml_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_a2 = /** @type {((inputs?: To_Yaml_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_a2(inputs)
	if (locale === "ko") return ko_to_yaml_faq_a2(inputs)
	return ja_to_yaml_faq_a2(inputs)
});